import { OPCOES_FILTRO_DATA } from '@constants/Text'
import { ANBIMA_STATUS } from '@modules/consolidator/constants/anbima-status'

const overviewStore = (store) => {
  const data = (store && store.getters['consolidator/overviewFilters']) || {}
  return data && typeof data === 'object' && !Array.isArray(data) ? data : {}
}

const listFrom = (store, key) => {
  const value = overviewStore(store)[key]
  return Array.isArray(value) ? value : []
}

export const TIPO_CLIENTE_DEFAULT = 'clientes'
export const STATUS_CLIENTE_DEFAULT = 'ativos'

export const TIPO_CLIENTE_OPTIONS = [
  { id: 'clientes', text: 'Clientes' },
  { id: 'leads', text: 'Leads' },
]

export const STATUS_CLIENTE_OPTIONS = [
  { id: 'ativos', text: 'Ativos' },
  { id: 'inativos', text: 'Inativos' },
]

export const STATUS_DESENQUADRAMENTO_KEY = 'status_desenquadramento'

// 'Abaixo do Risco' não entra aqui: o backend nunca retorna esse status
// (aawz_base/api/db_dir/anbima/utils_anbima_adherence.py:16,184 — "'Abaixo do
// Risco' is NEVER returned"), então essa opção sempre voltaria lista vazia.
export const STATUS_DESENQUADRAMENTO_OPTIONS = [
  ANBIMA_STATUS.ACIMA,
  ANBIMA_STATUS.PROXIMO,
  ANBIMA_STATUS.DENTRO,
  ANBIMA_STATUS.NAO_CONFIGURADO,
]

export const overviewFilters = [
  {
    label: 'Tipo de cliente',
    key: 'tipo_cliente',
    type: 'select-search',
    text: 'text',
    placeholder: 'Todos',
    options: TIPO_CLIENTE_OPTIONS,
    default: TIPO_CLIENTE_DEFAULT,
    clearTo: TIPO_CLIENTE_DEFAULT,
    cols: 12,
    props: { single: true },
  },
  {
    label: 'Status',
    key: 'status_cliente',
    type: 'select-search',
    text: 'text',
    placeholder: 'Todos',
    options: STATUS_CLIENTE_OPTIONS,
    default: STATUS_CLIENTE_DEFAULT,
    clearTo: STATUS_CLIENTE_DEFAULT,
    cols: 12,
    props: { single: true },
  },
  {
    label: 'Clientes',
    key: 'ids_clientes',
    type: 'slot',
    cols: 12,
  },
  {
    label: 'Classe de Ativos',
    key: 'classe_de_ativo',
    type: 'select-search',
    placeholder: 'Todas',
    cols: 12,
    optionsResolver: (store) => listFrom(store, 'classes_de_ativos'),
  },
  {
    label: 'Subclasse de Ativos',
    key: 'subclasse_de_ativo',
    type: 'select-search',
    placeholder: 'Todas',
    cols: 12,
    optionsResolver: (store) => listFrom(store, 'subclasses_de_ativos'),
  },
  {
    label: 'Ativos',
    key: 'nome_ativo',
    type: 'select-search',
    placeholder: 'Todos',
    cols: 12,
    optionsResolver: (store) => listFrom(store, 'nome_ativo'),
  },
  {
    label: 'Instituição',
    key: 'instituicao',
    type: 'select-search',
    placeholder: 'Todas',
    cols: 12,
    optionsResolver: (store) => listFrom(store, 'instituicoes'),
  },
  {
    label: 'Patrimônio',
    key: 'patrimonio',
    type: 'select-search',
    placeholder: 'Selecionar',
    cols: 12,
    props: { single: true, preserveItemsOrder: true },
    optionsResolver: (store) => listFrom(store, 'patrimonios'),
  },
  {
    label: 'Segmentação',
    key: 'segmentacao',
    type: 'select-search',
    placeholder: 'Todas',
    cols: 12,
    optionsResolver: (store) => listFrom(store, 'segmentacao'),
  },
  {
    label: 'Alocação Estratégica',
    key: 'status_alocacao_estrategica',
    type: 'select-search',
    placeholder: 'Todos',
    cols: 12,
    optionsResolver: (store) => listFrom(store, 'status_alocacao_estrategica'),
  },
  {
    label: 'Perfil do Investidor',
    key: 'perfil',
    type: 'select-search',
    placeholder: 'Todos',
    cols: 12,
    optionsResolver: (store) => listFrom(store, 'perfil'),
  },
  {
    label: 'Enquadramento ANBIMA',
    key: 'status_desenquadramento',
    type: 'select-search',
    placeholder: 'Todos',
    cols: 12,
    options: STATUS_DESENQUADRAMENTO_OPTIONS,
    props: { preserveItemsOrder: true },
  },
  {
    label: 'Portfólio',
    key: 'portfolio',
    type: 'select-search',
    placeholder: 'Todos',
    cols: 12,
    optionsResolver: (store) => listFrom(store, 'portfolios'),
  },
]

// Sem `abaixo`: o backend nunca emite 'Abaixo do Risco' (ver comentário de
// STATUS_DESENQUADRAMENTO_OPTIONS), então o deep link
// `?status_desenquadramento=abaixo` aplicava um filtro que voltava sempre
// vazio, para um status que nem aparece no seletor. Sem a entrada, o link
// antigo cai no early-return de overview-filters.vue:241 e a tela mostra
// tudo — errado de um jeito menos confuso que uma lista vazia sem motivo.
export const STATUS_DESENQUADRAMENTO_QUERY_MAP = {
  acima: ANBIMA_STATUS.ACIMA,
  dentro: ANBIMA_STATUS.DENTRO,
}

export const walletFilters = [
  { key: 'modoFiltroCorretora' },
  { key: 'filtroCorretora' },
  { key: 'investmentTypeFilter' },
  { key: 'filtroData', items: Object.values(OPCOES_FILTRO_DATA) },
]
